import { render, staticRenderFns } from "./StatusLight.vue?vue&type=template&id=5423d546&scoped=true&"
import script from "./StatusLight.vue?vue&type=script&lang=js&"
export * from "./StatusLight.vue?vue&type=script&lang=js&"
import style0 from "./StatusLight.vue?vue&type=style&index=0&id=5423d546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423d546",
  null
  
)

export default component.exports